import { useCallback } from "react"

export function useGtmEvent() {
  return useCallback((event: object) => {
    if (typeof window !== "undefined") {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push(event)
    }
  }, [])
}
